import { defineComponent as t, openBlock as n, createBlock as l, unref as a, mergeProps as p, withCtx as c, createElementVNode as i } from "vue";
import { RevIcon as m } from "@ds/components/Icon";
const u = /* @__PURE__ */ t({
  name: "IconArrowUpInCircleFilled",
  __name: "IconArrowUpInCircleFilled",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(r) {
    const o = r;
    return (s, e) => (n(), l(a(m), p(o, { "view-box": "0 0 24 24" }), {
      default: c(() => [...e[0] || (e[0] = [
        i("path", { d: "M18.894 5.106c3.808 3.807 3.808 9.98 0 13.788s-9.98 3.808-13.788 0-3.808-9.98 0-13.788 9.98-3.808 13.788 0m-6.01 1.96a1.25 1.25 0 0 0-1.768 0l-3.232 3.232a.75.75 0 0 0 1.06 1.06l2.306-2.305v7.19a.75.75 0 1 0 1.5 0v-7.19l2.306 2.305a.75.75 0 0 0 1.06-1.06l-3.232-3.233" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  u as default
};
